module.exports = __webpack_public_path__ + "img/5550.970a0b07.jpg";